import moment from "moment-timezone/moment-timezone"

$(document).on 'turbo:load', ->
  if $(".local-time").length
    new App.Ui.LocalTime()

class @App.Ui.LocalTime
  constructor: ->
    @bindElements()

  bindElements: ->
    $(".local-time").each ->
      $el = $(@)

      localDate = new Date $el.text()
      $el.text(moment(localDate).format("MMMM D, YYYY H:mm"))
